import i18n, * as i18next from 'i18next';
import {initReactI18next} from 'react-i18next';
import messages from './translations/iframe_messages.json';
import {DEBUG} from './config';
import axios from 'axios';

i18n.use(initReactI18next as i18next.Module) // passes i18n down to react-i18next
    .init({
        // list of available languages
        preload: ['ru', 'en'],
        resources: messages,
        lng: 'ru',
        debug: DEBUG,
        fallbackLng: 'ru',
        keySeparator: '.',

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

i18n.on("languageChanged", lng => {
    axios.defaults.headers.common["Accept-Language"] = "ru";
});

// i18n.languages = []
export {i18n};
export default i18next;
